const registeredModals = {
	options: () => (import('./options')),
	confirm: () => (import('./confirm')),
}

export default registeredModals;